import { render, staticRenderFns } from "./ServiceInnerPage.vue?vue&type=template&id=1fdf24ea&"
import script from "./ServiceInnerPage.vue?vue&type=script&lang=js&"
export * from "./ServiceInnerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports